import service from '@services';
import { PickupBar, Place, Business } from '@datamodel';
const PREFIX = '/places';

export const get = async (pk) => {
    const response = await service.get(`${PREFIX}/${pk}/`);
    if (response.status === 'ok') {
        return {
            status: 'ok',
            place: Place.parse(response.response),
            business: Business.parse(response.response.business || {}),
            pickupBars: PickupBar.parseArray(response.response.pickupbars || []),
            availableEvents: response.response.available_events
        }
    }
    throw service.error(response);
}

// 'id',
//     'slug',
//     'name',
//     'address',
//     'photo_url',
//     'logo_url',
//     'primary_color',
//     'minimum_order_amount',